// extracted by mini-css-extract-plugin
module.exports = {"pretitle":"PreTitle_pretitle__3HGW4"};